export default __webpack_public_path__ + "media/zurb/img/services/design-insight/design-insight-img4-4e8f58208917633bfbbaf2e974e1756e.png";